"use client";

import { useEffect, useState } from "react";
import { Image as MantineImage } from "@mantine/core";
import { responsiveImageProps } from "@/lib/shared/optimizedImage";

const IMAGE_SIZES = "(max-width: 768px) calc((100vw - 3.5rem) / 2), 300px";
const IMAGE_WIDTHS = [320, 480, 640] as const;

type Props = {
  src: string;
  alt: string;
  className?: string;
  onBroken?: () => void;
};

export const DropImage = ({ src, alt, className, onBroken }: Props) => {
  const [stage, setStage] = useState<"optimized" | "original" | "broken">("optimized");
  const optimizedImage = responsiveImageProps(
    IMAGE_WIDTHS.map((width) => ({ src, width })),
    { preferredWidth: 480 }
  );
  const canOptimize = optimizedImage.src !== src;

  useEffect(() => {
    setStage("optimized");
  }, [src]);

  const isOptimized = stage === "optimized" && canOptimize;
  const imageSrc =
    stage === "broken" ? "/kurb_broken_image.svg" : isOptimized ? optimizedImage.src : src;

  return (
    <MantineImage
      src={imageSrc}
      srcSet={isOptimized ? optimizedImage.srcSet : undefined}
      sizes={IMAGE_SIZES}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => {
        if (isOptimized) {
          setStage("original");
          return;
        }

        setStage("broken");
        onBroken?.();
      }}
    />
  );
};
